<template>
  <el-dialog
    title="绑定备案信息"
    :visible.sync="dialogVisible"
    width="820px"
    top="8vh"
    append-to-body
    :close-on-click-modal="false"
    @closed="handleClosed"
  >
    <div v-loading="submitLoading || detailLoading" class="bind-filing-wrap">
      <!-- 订单区块 -->
      <div v-for="(order, oIndex) in form.list" :key="oIndex" class="order-block">
        <div class="order-header">
          <div class="order-header-left">
            <span class="order-label">韩国单号：</span>
            <el-input
              v-model.trim="order.order_code"
              placeholder="请输入韩国单号"
              clearable
              style="width: 280px"
            />
          </div>
          <el-button
            type="danger"
            plain
            size="mini"
            icon="el-icon-delete"
            :disabled="form.list.length <= 1"
            @click="removeOrder(oIndex)"
          >
            删除订单
          </el-button>
        </div>

        <el-table :data="order.filing" border size="small" style="width: 100%">
          <el-table-column label="备案编码" min-width="240">
            <template #default="{ row }">
              <el-input v-model.trim="row.code" placeholder="请输入备案编码" clearable />
            </template>
          </el-table-column>
          <el-table-column label="数量" width="160" align="center">
            <template #default="{ row }">
              <el-input
                v-model.number="row.num"
                type="number"
                min="1"
                placeholder="请输入数量"
                clearable
              />
            </template>
          </el-table-column>
          <el-table-column label="操作" width="90" align="center">
            <template #default="{ $index }">
              <el-button
                type="danger"
                size="mini"
                icon="el-icon-delete"
                :disabled="order.filing.length <= 1"
                @click="removeFiling(order, $index)"
              />
            </template>
          </el-table-column>
        </el-table>

        <el-button
          type="primary"
          plain
          size="mini"
          icon="el-icon-plus"
          style="margin-top: 8px"
          @click="addFiling(order)"
        >
          添加备案
        </el-button>
      </div>

      <el-button
        type="success"
        plain
        size="small"
        icon="el-icon-plus"
        style="margin-top: 14px"
        @click="addOrder"
      >
        添加韩国单号
      </el-button>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" :loading="submitLoading" @click="handleSubmit">
        确 定
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { BuyOrderInfoAdd, BuyOrderInfoDetail } from '@/api/xgcApi'

export default {
  name: 'BindFiling',
  data() {
    return {
      dialogVisible: false,
      submitLoading: false,
      detailLoading: false,
      detailSeq: 0, // 请求序号，用于丢弃过期响应
      buy_id: null, // 代买订单 id
      form: {
        list: [],
      },
    }
  },
  methods: {
    /**
     * 打开弹窗
     * @param {Object} row 当前行数据（包裹数据）
     */
    showEdit(row) {
      this.buy_id = row.id
      // 先清空并给一条空白数据，保证即使接口异常也有可编辑的初始行
      this.form = { list: [this.createOrder()] }
      this.dialogVisible = true
      this.getDetail()
    },

    // 创建一条空的订单结构
    createOrder() {
      return {
        order_code: '',
        filing: [{ code: '', num: '' }],
      }
    },

    // 获取详情
    getDetail() {
      const seq = ++this.detailSeq
      const buyId = this.buy_id
      this.detailLoading = true

      BuyOrderInfoDetail({ buy_id: buyId })
        .then((res) => {
          // 丢弃过期响应（快速重复打开 / 已关闭弹窗）
          if (seq !== this.detailSeq) return

          // 兼容 data / data.list 两种返回结构，按实际接口调整
          const data = res && res.data ? res.data : {}
          const list = Array.isArray(data)
            ? data
            : Array.isArray(data.list)
            ? data.list
            : []

          if (list.length) {
            // 有详情 -> 回显
            this.form = {
              list: list.map((order) => {
                const filing =
                  Array.isArray(order.filing) && order.filing.length
                    ? order.filing
                    : [{ code: '', num: '' }]
                return {
                  order_code: order.order_code || '',
                  filing: filing.map((f) => ({
                    code: f.code || '',
                    // num 为空时保持空字符串，避免显示成 0
                    num: f.num === null || f.num === undefined ? '' : f.num,
                  })),
                }
              }),
            }
          } else {
            // 无详情 -> 新增
            this.form = { list: [this.createOrder()] }
          }
        })
        .catch(() => {
          if (seq !== this.detailSeq) return
          // 接口异常时保持可新增的空白表单
          this.form = { list: [this.createOrder()] }
        })
        .finally(() => {
          if (seq === this.detailSeq) {
            this.detailLoading = false
          }
        })
    },

    // 新增一个订单
    addOrder() {
      this.form.list.push(this.createOrder())
    },

    // 删除订单
    removeOrder(index) {
      this.form.list.splice(index, 1)
    },

    // 新增一条备案
    addFiling(order) {
      order.filing.push({ code: '', num: '' })
    },

    // 删除一条备案
    removeFiling(order, index) {
      order.filing.splice(index, 1)
    },

    // 校验
    validate() {
      if (!this.form.list.length) {
        this.$baseMessage('请至少添加一个订单', 'warning')
        return false
      }
      for (let i = 0; i < this.form.list.length; i++) {
        const order = this.form.list[i]
        if (!order.order_code) {
          this.$baseMessage(`第 ${i + 1} 个订单的订单编号不能为空`, 'warning')
          return false
        }
        if (!order.filing.length) {
          this.$baseMessage(`订单【${order.order_code}】至少需要一条备案信息`, 'warning')
          return false
        }
        for (let j = 0; j < order.filing.length; j++) {
          const item = order.filing[j]
          if (!item.code) {
            this.$baseMessage(`订单【${order.order_code}】第 ${j + 1} 条备案编码不能为空`, 'warning')
            return false
          }
          if (item.num === '' || item.num === null || item.num === undefined) {
            this.$baseMessage(`订单【${order.order_code}】第 ${j + 1} 条数量不能为空`, 'warning')
            return false
          }
          if (Number(item.num) <= 0) {
            this.$baseMessage(`订单【${order.order_code}】第 ${j + 1} 条数量必须大于 0`, 'warning')
            return false
          }
        }
      }
      return true
    },

    // 提交
    handleSubmit() {
      // 详情还没加载完，避免把空白数据提交上去
      if (this.detailLoading) {
        this.$baseMessage('详情加载中，请稍候', 'warning')
        return
      }
      if (!this.validate()) return

      const params = {
        buy_id: this.buy_id,
        list: this.form.list.map((order) => ({
          order_code: order.order_code,
          filing: order.filing.map((f) => ({
            code: f.code,
            num: String(f.num), // 接口要求字符串
          })),
        })),
      }

      this.submitLoading = true
      BuyOrderInfoAdd(params)
        .then((res) => {
          this.$baseMessage(res.msg || '绑定成功', 'success')
          this.dialogVisible = false
          this.$emit('change')
        })
        .catch(() => {})
        .finally(() => {
          this.submitLoading = false
        })
    },

    handleClosed() {
      this.detailSeq++ // 让未返回的详情请求失效
      this.detailLoading = false
      this.buy_id = null
      this.form = { list: [] }
    },
  },
}
</script>

<style scoped>
.bind-filing-wrap {
  max-height: 65vh;
  overflow-y: auto;
  padding-right: 6px;
}

.order-block {
  border: 1px solid #ebeef5;
  border-radius: 6px;
  padding: 12px;
  margin-bottom: 14px;
  background: #fafafa;
}

.order-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}

.order-header-left {
  display: flex;
  align-items: center;
}

.order-label {
  font-size: 14px;
  color: #606266;
  font-weight: 500;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
}
</style>